export default "__VITE_ASSET__Dt0HO6$1__"